import { useAppDispatch } from "@/app/store/hooks";
import Button from "@/shared/ui/buttons/Button";
import { SectionLayout } from "@/shared/ui/layouts/SectionLayout";
import Typography from "@/shared/ui/Typography";
import { requestFormModalOpen } from "@/widgets/modal/model/slice";

export interface IProjectMainSectionProps {
    name: string,
    title: string;
    presentation: string;
    bg: string | null;
}

export function ProjectMainSection({title, presentation, name, bg}: IProjectMainSectionProps) {

    const dispatch = useAppDispatch();

    const handleDownloadPresentaion = () => {
        dispatch(requestFormModalOpen({
            title: `загрузите презентацию ${name}`,
            link: presentation,
            download: true
        }))
    }

    return (
        <SectionLayout
            containerClassName="h-[600px] lg:h-[700px] flex justify-center items-center"
            style={{backgroundImage: `url(${bg? bg: '/images/defaults/card.png'})`}}
        >
            
            <div className="bg-white-20 flex flex-col w-[355px] md:w-[600px] items-center gap-[16px] mt-[100px] md:gap-[28px] shadow-glass px-[12px] py-[20px] md:p-[32px] rounded-[10px]">
                <Typography tag="h2" className="uppercase text-center !leading-[120%]">
                    {title}
                </Typography>

                <Button
                    className="bg-white-50 text-blue w-fit font-medium text-[14px] md:text-[16px] transition-colors duration-300 ease-in-out origin-left hover:text-white hover:bg-blue"
                    iconType="download"
                    onClick={handleDownloadPresentaion}
                >
                    Скачать презентацию по проекту                    
                </Button>
            </div>

        </SectionLayout>
    )
}
